import * as React from 'react';
import { colors } from '../../../index';

const IconBuilding = ({
  className = '',
  size = '1em',
  color,
  style = {}
}) => {
  const finalStyle = { ...style,
    fill: colors[color],
    color: colors[color]
  };
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 13 13",
    width: size,
    height: size,
    style: finalStyle,
    className: `icon ${className}`
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1-1h15v15H-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M6.5 3.375v-2.5H.25v11.25h12.5v-8.75H6.5zm-3.75 7.5H1.5v-1.25h1.25v1.25zm0-2.5H1.5v-1.25h1.25v1.25zm0-2.5H1.5v-1.25h1.25v1.25zm0-2.5H1.5v-1.25h1.25v1.25zm2.5 7.5H4v-1.25h1.25v1.25zm0-2.5H4v-1.25h1.25v1.25zm0-2.5H4v-1.25h1.25v1.25zm0-2.5H4v-1.25h1.25v1.25zm6.25 7.5h-5v-1.25h1.25v-1.25H6.5v-1.25h1.25v-1.25H6.5v-1.25h5v6.25zm-1.25-5H9v1.25h1.25v-1.25zm0 2.5H9v1.25h1.25v-1.25z"
  })));
};

export default IconBuilding;